import React from 'react';
import { DjayIllustrationProps } from '../types';
import { DjayIllustrationBase } from '../DjayIllustrationBase';
import { DjaySpecimen } from '../../DjaySpecimen';
export function ShadowRealmIllustration({
  achievementId,
  variant = 'shadow',
  // Unlocks shadow variant
  isUnlocked,
  rarity,
  size = 'md',
  animate = true,
  className = ''
}: DjayIllustrationProps) {
  return <DjayIllustrationBase isUnlocked={isUnlocked} rarity={rarity} size={size} className={className} data-id="element-4068" data-mp="10g67bcn0vqj5">
      <div className="relative w-full h-full bg-slate-950 overflow-hidden" data-id="element-4069" data-mp="vie4voor4m0p">
        {/* Background: Dark Aura */}
        <svg className="absolute inset-0 w-full h-full z-0" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-4070" data-mp="1a7sg72bw1diq">
          <circle cx="100" cy="100" r="80" fill="#4C1D95" opacity="0.3" filter="blur(20px)" data-id="element-4071" data-mp="howna9fmljdb" />
          <circle cx="100" cy="100" r="50" fill="#000000" opacity="0.5" filter="blur(10px)" data-id="element-4072" data-mp="3u57mgo0uiwr5" />

          {/* Shadow tendrils */}
          <path d="M100 100 Q40 40 20 80" stroke="#5B21B6" strokeWidth="8" strokeLinecap="round" opacity="0.4" filter="blur(2px)" data-id="element-4073" data-mp="6rbyhnwd4fnk" />
          <path d="M100 100 Q160 160 180 120" stroke="#5B21B6" strokeWidth="8" strokeLinecap="round" opacity="0.4" filter="blur(2px)" data-id="element-4074" data-mp="3b6v8moyzoyp8" />
          <path d="M100 100 Q150 40 120 20" stroke="#4C1D95" strokeWidth="6" strokeLinecap="round" opacity="0.5" filter="blur(2px)" data-id="element-4075" data-mp="3k4xa15mmxtd1" />
          <path d="M100 100 Q50 160 80 180" stroke="#4C1D95" strokeWidth="6" strokeLinecap="round" opacity="0.5" filter="blur(2px)" data-id="element-4076" data-mp="zidhy1738xcw" />
        </svg>

        {/* Djay */}
        <div className="absolute inset-0 z-10 flex items-center justify-center pt-[5%]" data-id="element-4077" data-mp="9swzt778qf9l">
          <div className="w-[70%] h-[70%] flex items-center justify-center" data-id="element-4078" data-mp="opxt3f52yia6">
            <DjaySpecimen look={{
            variant,
            accessory: 'shadowOrb'
          }} size="hero" emotion={isUnlocked ? 'surprised' : 'thinking'} animate={animate && isUnlocked} className="w-full h-full" data-id="element-4079" data-mp="jqbep2dimvzs" />
          </div>
        </div>

        {/* Foreground: Glowing Eyes / Dark Particles */}
        {isUnlocked && <svg className="absolute inset-0 w-full h-full z-20 pointer-events-none" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-4080" data-mp="zk27ry8eph6">
            {/* Particles */}
            <circle cx="40" cy="60" r="3" fill="#A78BFA" opacity="0.8" data-id="element-4081" data-mp="34eg0xvbgt8x9" />
            <circle cx="160" cy="80" r="2" fill="#8B5CF6" opacity="0.6" data-id="element-4082" data-mp="1jxq1syenrjf6" />
            <circle cx="140" cy="150" r="4" fill="#C4B5FD" opacity="0.5" data-id="element-4083" data-mp="1ophrz7twjn4s" />
            <circle cx="60" cy="140" r="2.5" fill="#7C3AED" opacity="0.7" data-id="element-4084" data-mp="1a0bsrjv2dwww" />

            {/* Vignette border */}
            <rect x="0" y="0" width="200" height="200" fill="url(#vignette)" data-id="element-4085" data-mp="1eyvilvcs3suj" />
            <defs data-id="element-4086" data-mp="22ozlu1m21ql0">
              <radialGradient id="vignette" cx="50%" cy="50%" r="50%" fx="50%" fy="50%" data-id="element-4087" data-mp="22ohikl0z6c3l">
                <stop offset="70%" stopColor="black" stopOpacity="0" data-id="element-4088" data-mp="1tougdx0f929h" />
                <stop offset="100%" stopColor="black" stopOpacity="0.6" data-id="element-4089" data-mp="1tqnkb4jnh8ds" />
              </radialGradient>
            </defs>
          </svg>}
      </div>
    </DjayIllustrationBase>;
}